export default __webpack_public_path__ + "static/media/error-outline-24-px.28b28f5b.svg";